import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";

export const getUserProfile = async () => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/auth/users/me/`;
        const response = await axios.get(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Data retrieval failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};
